import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { DynamicIcon } from '@/components/icons/DynamicIcon'
import { DropdownMenuItem } from '@/components/shadcn/dropdown-menu'
import { useSubmitForm } from '../../FormComponent/useSubmitForm'
import { DataTableV2DataRow, DataTableV2SubmissionAction } from '../types'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { Button } from '@/components/shadcn/button'

export function SubmitActionNoConfirmation({
  action,
  formData,
  actionPosition = 'row',
}: {
  action: DataTableV2SubmissionAction
  formData?: DataTableV2DataRow
  actionPosition?: 'table' | 'row'
}) {
  const { handlerId, id: actionId, label, icon } = action
  const { tileFilterSelections } = useTileFilters()
  const { mutate: submitForm } = useSubmitForm(handlerId, [...tileFilterSelections, { actionId }], actionId)

  const trigger =
    actionPosition === 'row' ? (
      <DropdownMenuItem
        key={actionId}
        onSelect={(_e) => {
          // e.preventDefault()
          submitForm(formData as Record<string, unknown>)
        }}
        disabled={action.isDisabled}
      >
        <div className="flex items-center gap-2">
          <DynamicIcon iconName={icon || ''} lazyLoad={false} className="size-3" />
          <span>{label}</span>
        </div>
      </DropdownMenuItem>
    ) : (
      <TooltipButton tooltip={label}>
        <Button
          variant="ghost"
          size="icon"
          className="size-6"
          disabled={action.isDisabled}
          onClick={() => submitForm((formData ?? {}) as Record<string, unknown>)}
        >
          <DynamicIcon iconName={icon || ''} lazyLoad={false} /* className="size-3" */ />
          <span className="sr-only">{label}</span>
        </Button>
      </TooltipButton>
    )

  return trigger
}
